export const EC_AUTH_BE_V2 = () => {
  return window.location.host.includes("localhost")
    ? `https://dev.eclear-solutions.com/ec-authorization-be/v2/`
    : `https://${window.location.host}/ec-authorization-be/v2/`;
};

export const URLS = {
  // ______________________BASE URLS______________________

  ECLEAR_BASE_URL: () => {
    return window.location.href.includes("localhost")
      ? "https://dev.eclear-solutions.com/"
      : `https://${window.location.host}/`;
  },
  ECLEAR_DEV: "https://dev.eclear-solutions.com/ec-spot-be/v1/",
  ECLEAR_PROD: "https://eclear-solutions.com/ec-spot-be/v1/",
  DHL_DEV: "https://dhl-dev.eclear-solutions.com/ec-spot-be/v1/",
  JERA_DEV: "https://dev-jera.eclear-solutions.com/ec-spot-be/v1/",
  JERA_PROD: "https://jera.eclear-solutions.com/ec-spot-be/v1/",
  WORLDLINE_DEV: "https://dev-worldline.eclear-solutions.com/ec-spot-be/v1/",
  WORLDLINE_PROD: "https://worldline.eclear-solutions.com/ec-spot-be/v1/",
  PAYONE_PROD: "https://payone.eclear-solutions.com/login",
  PAYONE_DEV: "https://dev-payone.eclear-solutions.com/login",
  EC_MEDIA_DEV: "https://dev.eclear-solutions.com/ec-media-be/v1/media/",
  EC_MEDIA_DEV_JERA:
    "https://dev-jera.eclear-solutions.com/ec-media-be/v1/media/",
  EC_MEDIA_DEV_WORLDLINE:
    "https://dev-worldline.eclear-solutions.com/ec-media-be/v1/media/",
  EC_MEDIA_PROD: "https://eclear-solutions.com/ec-media-be/v1/media/",
  EC_MEDIA_PROD_JERA: "https://jera.eclear-solutions.com/ec-media-be/v1/media/",
  EC_MEDIA_PROD_WORLDLINE:
    "https://worldline.eclear-solutions.com/ec-media-be/v1/media/",
  EC_MEDIA_ADMIN: () => {
    return window.location.host.includes("localhost") ||
      window.location.host.includes("prod")
      ? "https://ref.eclear-solutions.com/ec-spot-be/v1/admin/media/"
      : `/ec-spot-be/v1/admin/media/`;
  },

  EC_SPOT_BE: () => {
    switch (true) {
      case window.location.host.includes("localhost"):
        return "https://dev.eclear-solutions.com/ec-spot-be/v1/";
      case window.location.host.includes("ref"):
        return "https://ref.eclear-solutions.com/ec-spot-be/v1/";
      default:
        return `https://${window.location.host}/ec-spot-be/v1/`;
    }
  },

  EC_CLEAR_CUSTOMS_BE: () => {
    switch (true) {
      case window.location.host.includes("localhost"):
        return "https://dev.eclear-solutions.com/ec-clearcustoms-be/v1/";
      case window.location.host.includes("ref"):
        return "https://ref.eclear-solutions.com/ec-clearcustoms-be/v1/";
      default:
        return `https://${window.location.host}/ec-clearcustoms-be/v1/`;
    }
  },
  EC_MEDIA_BE: () => {
    switch (true) {
      case window.location.href.includes("localhost"):
        return "https://dev.eclear-solutions.com/ec-media-be/v1/media/";
      case window.location.href.includes("ref"):
        return "https://ref.eclear-solutions.com/ec-media-be/v1/media/";
      default:
        return `https://${window.location.host}/ec-media-be/v1/media/`;
    }
  },

  EC_AUTH_BE: () => {
    return window.location.host.includes("localhost")
      ? `https://dev.eclear-solutions.com/ec-authorization-be/v1/`
      : `https://${window.location.host}/ec-authorization-be/v1/`;
  },

  SUBSCRIPTION_MANAGEMENT: () => {
    return window.location.host.includes("localhost")
      ? `https://dev.eclear-solutions.com/ec-authorization-be/v1/subscription-management/`
      : `https://${window.location.host}/ec-authorization-be/v1/subscription-management/`;
  },

  // ______________________ec-spot-be ENDPOINTS______________________
  COUNTRY_REPORT_YEAR: "dashboard/country-report-year/",
  USER_STATUS: "user/status/",
  USER_STATUS_VALUES: "user/status/values",
  REPORT_ACTUAL_YEAR: "dashboard/report-actual-year/",
  REPORT_ACTUAL_MONTH: "dashboard/report-actual-month/",
  TOTAL_REVENUE_TOP_COUNTRY: "dashboard/cart/total-revenue-top-country-compare",
  TOTAL_REVENUE_TOP_PRODUCT: "dashboard/cart/total-revenue-top-product-compare",
  LAST_30_DAYS: "dashboard/last-thirty-days/",
  CONNECTOR_CONFIG: "configuration",
  // GENERATE_AUTH_TOKEN: "auth/aws/generate-tokens-from-cognito-code", // AWS Cognito endpoint removed
  FLOW_MAP_REPORT_YEAR: "dashboard/flowmap-report-year/",
  INVOICE_VALID_TAX_REPORT: "dashboard/invoice-valid-tax-report/",
  PRODUCT_VALID_TAX_REPORT: "dashboard/product-valid-tax-report/",
  REGISTRATION_LINK: "registration-link/",
  ADMIN_DASHBOARD: "admin/dashboard",
  UPDATE_COMPANY_INFO: (companyId) => {
    return `${EC_AUTH_BE_V2()}merchant/${companyId}`;
  },

  // ______________________ec-media-be ENDPOINTS______________________
  //
  CREATE_ACCESS_KEY: (merchantId) => {
    return `admin/media/${merchantId}/access/create`;
  },
  LIST_ACCESS_KEY: (merchantId) => {
    return `admin/media/${merchantId}/access/list`;
  },
  DISABLE_ACCESS_KEY: "access/disable/",
  TEST_ACCESS_KEY: "connection/test",
  DATA_FILES_LIST: (merchantId) => {
    return `admin/media/${merchantId}/upload/list`;
  },
  UPLOAD_DATA_FILE: "upload/spot",
  MERCHANT_ACCESS_KEY: (merchantId) => {
    return `${merchantId}/access/list`;
  },
  CREATE_ACCESS_KEY_ADMIN: (merchantId) => {
    return `${merchantId}/access/create`;
  },

  // ______________________subscription-management ENDPOINTS______________________
  GENERATE_PORTAL_SESSION: "generate-portal-session",

  // ______________________user-management ENDPOINTS______________________

  REQUEST_PASSWORD_UPDATING: () => {
    return window.location.host.includes("localhost")
      ? `https://dev.eclear-solutions.com/ec-authorization-be/v1/user-manager/request-password-updating`
      : `https://${window.location.host}/ec-authorization-be/v1/user-manager/request-password-updating`;
  },
  PASSWORD_UPDATE: () => {
    return window.location.host.includes("localhost")
      ? `https://dev.eclear-solutions.com/ec-authorization-be/v1/user-manager/password-update`
      : `https://${window.location.host}/ec-authorization-be/v1/user-manager/password-update`;
  }
};

export const URLS_USERS = (companyId) => {
  return `company/${companyId}/users`;
};

// curl --location 'https://dev.eclear-solutions.com/ec-authorization-be/v1/user-manager/request-password-updating' \
// --header 'Content-Type: application/json' \
// --data-raw '{
//     "email": "user@eclear.com",
//     "password":"1qay!QAY"
// }'

// curl --location 'https://dev.eclear-solutions.com/ec-authorization-be/v1/user-manager/password-update' \
// --data-raw '{
//     "email": "user@eclear.com",
//     "password":"1qay!QAY1",
//     "code": "593207"
//     }'
